import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './services/AuthContext';
import { CustomerAuthProvider } from './services/CustomerAuthContext';
import Home from './pages/Home';
import VendorRegister from './pages/VendorRegister';
import VendorLogin from './pages/VendorLogin';
import VendorDashboard from './pages/VendorDashboard';
import VendorBooth from './pages/VendorBooth';
import Artisans from './pages/Artisans';
import Admin from './pages/Admin';
import WorkshopBrowse from './pages/WorkshopBrowse';
import BlueprintDetail from './pages/BlueprintDetail';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import CustomerRegister from './pages/CustomerRegister';
import CustomerLogin from './pages/CustomerLogin';
import CustomerDashboard from './pages/CustomerDashboard';
import CommissionBoard from './pages/CommissionBoard';
import './App.css';

function App() {
  return (
    <AuthProvider>
      <CustomerAuthProvider>
        <Router>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/vendor/register" element={<VendorRegister />} />
            <Route path="/vendor/login" element={<VendorLogin />} />
            <Route path="/vendor/dashboard" element={<VendorDashboard />} />
            <Route path="/booth/:vendorId" element={<VendorBooth />} />
            <Route path="/artisans" element={<Artisans />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="/workshop/blueprints" element={<WorkshopBrowse />} />
            <Route path="/workshop/blueprints/:id" element={<BlueprintDetail />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/customer/register" element={<CustomerRegister />} />
            <Route path="/customer/login" element={<CustomerLogin />} />
            <Route path="/commissions" element={<CustomerDashboard />} />
            <Route path="/commission-board" element={<CommissionBoard />} />
          </Routes>
        </Router>
      </CustomerAuthProvider>
    </AuthProvider>
  );
}

export default App;
